import { render, staticRenderFns } from "./marketingInfo.vue?vue&type=template&id=45dea81c&"
import script from "./marketingInfo.vue?vue&type=script&lang=js&"
export * from "./marketingInfo.vue?vue&type=script&lang=js&"
import style0 from "./marketingInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports